module.exports = __webpack_public_path__ + "img/photo1.030b5887.jpg";